<template>
  <div class="toggle-switch" :class="{ checked: modelValue }" @click="toggle" />
</template>

<script>
  import { toRef } from "@vue/composition-api";

  export default {
    props: {
      modelValue: {
        required: true,
        type: Boolean,
      },
    },
    emits: ["update:modelValue"],
    setup(props, { emit }) {
      const modelValue = toRef(props, "modelValue");

      const toggle = () => {
        emit("update:modelValue", !modelValue.value);
      };

      return {
        toggle,
      };
    },
  };
</script>

<style scoped>
  .toggle-switch {
    background: #dad9dd;
    border-radius: 24px;
    box-shadow: 0.0625em 0.0625em 0.0625em rgba(0, 0, 0, 0.08) inset;
    cursor: pointer;
    flex: none;
    height: 24px;
    position: relative;
    transition: background-color 150ms;
    width: 39px;
  }

  .toggle-switch::before {
    background: #fff;
    background-image: radial-gradient(circle at 0.375em 0.375em, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.05) 1em);
    border-radius: 50%;
    box-shadow: 0.0625em 0.0625em 0.0625em rgba(0, 0, 0, 0.08);
    content: "";
    display: block;
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    position: absolute;
    transition: left 150ms;
    will-change: left;
  }

  .checked {
    background-color: #22b94d;
  }

  .checked::before {
    background-image: radial-gradient(circle at 0.375em 0.375em, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.05) 1em);
    left: unset;
    right: 3px;
  }

  .toggle-switch:hover {
    box-shadow: 0.0625em 0.0625em 3px rgba(0, 0, 0, 0.12) inset;
  }

  .toggle-switch:hover::before {
    background-image: radial-gradient(circle at 0.375em 0.375em, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.0375) 1em);
    box-shadow: 0.0625em 0.0625em 0.0625em rgba(0, 0, 0, 0.12);
  }
</style>
